import { FolderableCollectionLoadOnScrollServiceBase } from 'FoldersApp/services/folderable-collection-load-on-scroll-service-base.service';
import { TalkingPointsService } from 'TalkingPointsApp/services/talking-points.service';
import { formFlattenedObject } from 'NewAngular/utils/urls';
import * as i0 from "@angular/core";
import * as i1 from "TalkingPointsApp/services/talking-points.service";
export class TalkingPointFolderableCollectionListModalService extends FolderableCollectionLoadOnScrollServiceBase {
    get folderableCollection$() {
        if (this.dataParams === null)
            return null;
        const dataParams = formFlattenedObject(this.dataParams, Object.keys(this.dataParams));
        return this.talkingPointsService.getFolderableItems(dataParams);
    }
    constructor(talkingPointsService) {
        super();
        this.talkingPointsService = talkingPointsService;
    }
}
TalkingPointFolderableCollectionListModalService.ɵfac = function TalkingPointFolderableCollectionListModalService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TalkingPointFolderableCollectionListModalService)(i0.ɵɵinject(i1.TalkingPointsService)); };
TalkingPointFolderableCollectionListModalService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TalkingPointFolderableCollectionListModalService, factory: TalkingPointFolderableCollectionListModalService.ɵfac });
